import React from 'react';
import { ProfileCompletionConst } from '@axiom/const';

import type { BannerPromptProps } from '../ProfileCompletionBanner/ProfileCompletionBanner';
import { ProfileCompletionBanner } from '../ProfileCompletionBanner/ProfileCompletionBanner';

export const EducationBannerPrompt = ({
  onOpenEdit,
  name = 'EDUCATION_BANNER_PROMPT',
}: {
  onOpenEdit?: BannerPromptProps['onOpenEdit'];
  name?: BannerPromptProps['name'];
}) => {
  return (
    <ProfileCompletionBanner
      items={[
        {
          title:
            ProfileCompletionConst.ProfileCompletionEducationBanner
              .missingTitle,
          description:
            ProfileCompletionConst.ProfileCompletionEducationBanner
              .missingContent,
          estimatedTime: '5 min',
        },
      ]}
      onOpenEdit={onOpenEdit}
      name={name}
    />
  );
};
